import React from 'react'
import { isEmpty } from 'lodash'
import { Redirect } from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import { deepOrange500, lightGreenA700 } from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import ProjectTypeForm from './ProjectTypeForm'

import Resource from '../../stores/resource'
const ProjectTypeStore = Resource('project-types')

class EditProjectType extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      projectType: this.props.projectType || {},
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = attributes => {
    ProjectTypeStore.update(this.state.projectType.id, attributes)
      .then(result => {
        this.setState(
          {
            saved: true,
            changed: false,
            error: '',
            savedProjectType: result.data.data,
            snackbarMessage: `ProjectType "${attributes.name}" saved!`
          },
          () => {
            if (this.props.savedCallback) {
              this.props.savedCallback(this.state.savedProjectType)
            }
          }
        )
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _changed = didChange => this.setState({ changed: didChange, saved: false })

  _closeErrorDialog = () => this.setState({ error: '' })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    const { redirect, changed, saved, snackbarMessage, error } = this.state

    if (redirect) return <Redirect push to={redirect} />

    const projectType = isEmpty(this.state.projectType)
      ? null
      : this.state.projectType

    const name = projectType.attributes ? projectType.attributes.name : ''

    return (
      <section>
        <ProjectTypeForm
          formTitle={
            <span>
              {name}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500} />}
              {saved && <ActionCheckCircle color={lightGreenA700} />}
            </span>
          }
          projectType={projectType}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo('/project-types')}
        />

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes"
        >
          <p>
            The project type <strong>{name}</strong> remains unchanged.
          </p>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditProjectType



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/EditProjectType.jsx